module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Tag Utenti","pageMetaDescription":"Tag Utenti","newSkill":"Nuovo tag","agencySkillDelete":"Tag eliminato con successo","agencySkillDeleteError":"Impossibile eliminare il tag","editSkill":"Modifica tag","formSkillDetails":{"Name":"Tag","IsActive":"Attivo?"},"userManagement":"Gestione Utenti","tagAdded":"Tag creato!"}}')
  delete Component.options._Ctor
}
